import styled from "styled-components";

export const SubsctibtionAlertText = styled.p`
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-sm);
  }
`;
